import { z } from "zod";

import { JunkDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { Patient, patientSchema } from "@/src/models/patient";
import { practitionerSchema } from "@/src/models/practitioner";

export const junkTypeDisplay: Record<JunkDocumentType, string> = {
  [JunkDocumentType.JUNK]: "Junk",
  [JunkDocumentType.FAILED_FAX]: "Failed Fax",
};

export const junkSchema = z.object({
  patient: patientSchema,
  receivingProvider: practitionerSchema.nullable(),
});

export type Junk = Omit<z.infer<typeof junkSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const junkShape: Junk = {
  id: "",
  patient: null,
  receivingProvider: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
